// Network report — Jun 18 → Aug 13, 2026 (57 days)
// Sources (all scraped 2026-08-13; the data/2026-07-18/ folder name is a
// mislabel from a bad session clock, every file in it is scrapedAt 2026-08-13):
//  - Apify, every post individually dated: main-ig, main-yt, labs-ig,
//    main-tt, unseen-ig, masked-ig.
//  - The three fan YouTube channels come from a yt-dlp pull where window
//    attribution is approximate. They account for 449 views total.
//  - NOT measured (Apify usage cap reached): unseen-tt, masked-tt, labs-tt.
//    Lifetime views as of the Jul 7 report: 3, 1 and 0 respectively.
//  - labs-ig returned posts back to Jul 30 only, so its figures are a floor.
//  - All numbers are measured public metrics. Nothing estimated.
//  - Shares are deliberately absent: only TikTok exposes share counts publicly,
//    Instagram and YouTube report them to the account owner only.

export const WINDOW = {
    label: 'Jun 18 to Aug 13, 2026',
    days: 57,
    badge: '8-Week Network Report',
};

export const TOTALS = {
    views: 936834,
    likes: 12959,
    comments: 744,
    accountCount: 12,
    measuredAccounts: 9,
    platformCount: 3,
};

export const MAIN = {
    ig: { platform: 'Instagram', handle: '@themaskwithabhiveer', views: 795653, likes: 11880, comments: 696 },
    yt: { platform: 'YouTube', handle: '@themaskwithabhiveer', views: 68877, likes: 686, comments: 42 },
    tt: { platform: 'TikTok', handle: '@themaskwithabhiveer', views: 1223, likes: 41, comments: 0 },
};

export const FAN_PAGES = [
    { persona: 'Unseen', platform: 'Instagram', handle: '@unseenabhiveer', views: 54093, likes: 264, comments: 5 },
    { persona: 'Masked', platform: 'Instagram', handle: '@themaskedabhi', views: 10639, likes: 48, comments: 1 },
    { persona: 'Labs', platform: 'Instagram', handle: '@abhiveerlabs', views: 5900, likes: 40, comments: 0 },
    { persona: 'Unseen', platform: 'YouTube', handle: '@UnseenAbhiveer', views: 107, likes: null, comments: null },
    { persona: 'Masked', platform: 'YouTube', handle: '@TheMaskedAbhi', views: 204, likes: null, comments: null },
    { persona: 'Labs', platform: 'YouTube', handle: '@abhiveerlabs', views: 138, likes: null, comments: null },
    { persona: 'Unseen', platform: 'TikTok', handle: '@unseenabhiveer', unmeasured: true },
    { persona: 'Masked', platform: 'TikTok', handle: '@themaskedabhi', unmeasured: true },
    { persona: 'Labs', platform: 'TikTok', handle: '@abhiveerlabs', unmeasured: true },
];

export const FOOTNOTE = 'Likes and comments were not collected on the three fan YouTube channels this cycle. The three fan TikTok accounts are not measured here. Shares are absent because only TikTok reports them publicly, Instagram and YouTube show shares to the account owner only.';

export const BUILT = {
    windowLabel: '18 June and 13 August',
    items: [
        { icon: 'film', title: '5 new main-page reels', body: 'Written and cut for the main page: butterflies, real love, short-term pain, fake healthy food, and two hurt children.' },
        { icon: 'layers', title: 'Scripted B-roll for every reel', body: 'Each reel researched and shot-listed beat by beat, so the visuals carry the script instead of sitting under it as filler.' },
    ],
};

export const formatNum = (n) => {
    if (n === null || n === undefined) return '—';
    return n.toLocaleString();
};
